import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { deleteSchool, deleteTeacher, deleteAdminClass } from '../../../redux';
import { Link, useNavigate } from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import '../../Components/dashboard.css';
import './index.css';
import AdminTile from './AdminTile';

function SchoolEdit (props) {
    const {
        schoolTeachers,
        schoolClasses,
        school,
        schools,
        history,
    } = props;

    const navigate = useNavigate();
    const [teachers, setTeachers] = useState([]);
    const [classes, setClasses] = useState([]);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const teacherSort = (a, b) => {
        if (a.lastName < b.lastName) return -1;
        if (a.lastName > b.lastName) return 1;
        if (a.firstName < b.firstName) return -1;
        if (a.firstName > b.firstName) return 1;
        return 0;
    }

    const classSort = (a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
    }

    useEffect(() => {
        setTeachers(schoolTeachers.sort(teacherSort));
        setClasses(schoolClasses.sort(classSort));
    }, [schoolTeachers, schoolClasses])

    const mappedTeachers = () => {
        return teachers && teachers
            .map((teacher, index) => {
                const filteredClasses = classes
                    // eslint-disable-next-line
                    .filter(thisClass => thisClass.teachers.some(thisTeacher => thisTeacher == teacher._id))
                    .map(thisClass => `${thisClass.name}`);
                return (
                    <div className="schoolTileContainer" key={index + "teacherContainer"}>
                        <AdminTile
                            key={index + teacher.firstName}
                            name={`${teacher.lastName}, ${teacher.firstName}`}
                            sub={teacher.email}
                            type="Classes"
                            hiddenItems={filteredClasses}
                            handleDelete={() => props.deleteTeacher(teacher._id, schoolTeachers)}
                        />
                    </div>
                );
            });
    }

    const mappedClasses = () => {
        return classes && classes
            .map((thisClass, index) => {
                const filteredTeachers = teachers
                    // eslint-disable-next-line
                    .filter(thisTeacher => thisClass.teachers.some(teacherId => teacherId == thisTeacher._id))
                    .map(teacher => `${teacher.lastName}, ${teacher.firstName}`);
                return (
                    <div className="schoolTileContainer" key={index + "classContainer"}>
                        <AdminTile
                            key={index + thisClass.name}
                            name={thisClass.name}
                            sub={thisClass.status}
                            type="Teachers"
                            hiddenItems={filteredTeachers}
                            handleDelete={() => props.deleteAdminClass(thisClass._id, schoolClasses)}
                        />
                    </div>
                );
            });
    }

    const handleSchoolDelete = () => {
        setDeleteDialogOpen(true);
    }

    const handleDeleteConfirm = () => {
        props.deleteSchool(school._id, schools);
        setDeleteDialogOpen(false);
        navigate("/admin");
    }

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
    }

    return (
        <div className="dashboard adminSchoolPage">
            <Link to="/admin" className="backButton">
                <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                Return to Dashboard
            </Link>
            <h1>Viewing <span style={{color: "#ef6a6e"}}>{school.name}</span></h1>
            <h3 style={{marginTop: "35px"}}>Teachers</h3>
            <div className="tiles">
                {mappedTeachers()}
            </div>
            <h3>Classes</h3>
            <div className="tiles">
                {mappedClasses()}
            </div>
            <h3>Danger Zone</h3>
            <button onClick={handleSchoolDelete} className="actionButton" style={{marginTop: "50px"}}>
                Delete School
            </button>
            
            <Dialog open={deleteDialogOpen} onRequestClose={handleDeleteCancel}>
                <div>
                    <h3>Are you sure you want to delete this school?</h3>
                    <p>This action cannot be undone and will remove:</p>
                    <ul style={{marginLeft: "20px", marginBottom: "20px"}}>
                        <li>All teachers associated with this school</li>
                        <li>All classes and their data</li>
                        <li>All student evaluations and assignments</li>
                        <li>All feedback and analytics data</li>
                    </ul>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "20px 10px",
                            gap: "24px",
                        }}
                    >
                        <button onClick={handleDeleteCancel} className="actionButton">
                            Cancel
                        </button>
                        <button className="actionButton" onClick={handleDeleteConfirm}>
                            Delete School
                        </button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(state => state.root, { deleteSchool, deleteTeacher, deleteAdminClass })(SchoolEdit);
